//#region src/date-picker/types/date-time-format.ts
var e = /* @__PURE__ */ function(e) {
	return e.dateFirst = "d/m/Y", e.monthFirst = "m/d/Y", e;
}({}), t = /* @__PURE__ */ function(e) {
	return e.hourMinute = "H:i", e.hourMinuteAmPm = "h:i A", e.hourMinuteSecond = "H:i:s", e.hourMinuteSecondAmPm = "h:i:s A", e;
}({});
//#endregion
export { e as DateFormatEnum, t as TimeFormatEnum };
